import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';


const BRAND = 'Simsola AI';
const MIN_TITLE_LENGTH = 30;

const DEFAULT_BASE_TITLE =
  'AI Training Platform for Leadership Development';

const ROUTE_TITLES: Record<string, string> = {
  '/about-us': 'About Simsola AI – Our Mission & Leadership Training Vision',
  '/assessment-service': 'Assessment Service for Businesses – Consistent, API-First Candidate Assessments',
  '/assessment-service/candidates': 'Simsola Prep – Private, Skill-by-Skill Interview Feedback for Candidates',
  '/book-a-demo': 'Book a Demo of Simsola AI – Experience AI-Powered Training',
  '/contact-us': 'Contact Simsola AI – Talk to Our AI Training Experts',
  '/news/tmn-choice-awards-2026': 'Simsola Wins 2026 Training Magazine Network Choice Award',
  '/privacy-policy': 'Privacy Policy – Data Protection & Security',
  '/product': 'Simsola AI Product – Immersive AI Training Platform Features',
  '/product/6d-assessment': 'Simsola 6D Assessment | Evaluate Leadership Across 6 Dimensions',
  '/resource-download': 'Leadership Development in the AI Era – Free Whitepaper',
  '/resources': 'Leadership Training Resources, Guides & Insights',
  '/results': 'Customer Results & Impact from Simsola AI Training',
  '/terms-of-use': 'Terms of Use – Platform Usage Guidelines',
  '/trust-center': 'Trust Center – Security, Compliance & Privacy',
  '/vision': 'Our Vision for AI-Powered Leadership Training'
};

const buildTitle = (baseTitle: string) => {
const DESCRIPTIVE_ADDITION = 'AI Training Platform for Leadership';
  let title = `${baseTitle} | ${BRAND}`;

  if (title.length < MIN_TITLE_LENGTH) {
    title = `${baseTitle} – ${DESCRIPTIVE_ADDITION} | ${BRAND}`;
  }

  return title;
};

const FULL_TITLES: Record<string, string> = {
  '/': 'Simsola AI | The Last Mile of Hiring'
};

export const SeoTitle: React.FC = () => {
  const location = useLocation();

  const baseTitle =
    ROUTE_TITLES[location.pathname] || DEFAULT_BASE_TITLE;

  const finalTitle =
    FULL_TITLES[location.pathname] || buildTitle(baseTitle);

  return (
    <Helmet>
      <title>{finalTitle}</title>
    </Helmet>
  );
};
